import React, { useCallback, useMemo } from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { number, required } from 'Utils/Validators/formValidation'
import { addInventoryItem } from 'Reducers/Inventory/actions'
import { findPowerBankTypeId } from 'Utils/PowerBanks'

import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { Input } from 'Components/Form/Input'
import { SelectDashboard } from 'Components/Form/SelectDashboard'
import Button from 'Components/Form/Button'
import Form from 'Components/Form'

import { useTypeAndClientOptions } from '../../utils'

const SIZE_AND_QUANTITY_OPTIONS = [
  { label: 'N/A', value: 'N/A' },
  { label: 'XS', value: 'XS' },
  { label: 'S', value: 'S' },
  { label: 'M', value: 'M' },
  { label: 'L', value: 'L' },
  { label: 'XL', value: 'XL' },
  { label: 'XXL', value: 'XXL' },
  { label: 'XXXL', value: 'XXXL' },
  { label: 'XXXXL', value: 'XXXXL' },
]

const InventoryAddModal = props => {
  const { handleCancel, handleConfirm } = props
  const dispatch = useDispatch()
  const { cityId } = useParams()

  const { typeOptions, clientOptions } = useTypeAndClientOptions()

  // Power banks are one row per physical unit (serial + hold), so they are
  // never added with a free quantity here: the CSV upload is the only way in.
  const addableTypeOptions = useMemo(() => {
    const powerBankTypeId = findPowerBankTypeId(
      typeOptions.map(option => ({ id: option.value, name: option.label })),
    )
    if (!powerBankTypeId) return typeOptions
    return typeOptions.filter(
      option => String(option.value) !== powerBankTypeId,
    )
  }, [typeOptions])

  const onConfirm = useCallback(
    (e, { data }) => {
      const { quantity, typeId, size, clientId } = data

      dispatch(
        addInventoryItem({
          cityId,
          typeId: typeId.value,
          description: size.value,
          quantity: Number(quantity.value),
          comments: 'Item added on inventory page.',
          clientId: clientId.value,
        }),
      )

      handleConfirm()
    },
    [cityId],
  )

  return (
    <Modal show onHide={handleCancel}>
      <Form>
        <ModalHeader closeButton>
          <ModalTitle>Add Inventory</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <Grid spacing={3} container>
            <Grid item xs={6}>
              <SelectDashboard
                name="clientId"
                label="Client"
                options={clientOptions}
                validator={[required]}
              />
            </Grid>
            <Grid item xs={6}>
              <Input
                name="quantity"
                label="Quantity"
                validator={[required, number]}
              />
            </Grid>
          </Grid>
          <Grid spacing={3} container>
            <Grid item xs={6}>
              <SelectDashboard
                name="typeId"
                label="Type"
                options={addableTypeOptions}
              />
            </Grid>
            <Grid item xs={6}>
              <SelectDashboard
                name="size"
                label="Size"
                options={SIZE_AND_QUANTITY_OPTIONS}
              />
            </Grid>
          </Grid>
        </ModalBody>
        <ModalFooter>
          <Button
            className="submit-button"
            value="Cancel"
            onClick={handleCancel}
          />
          <Button value="Save" onClick={onConfirm} />
        </ModalFooter>
      </Form>
    </Modal>
  )
}

export default InventoryAddModal
